/* eslint-disable prettier/prettier */
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle
} from 'mdb-react-ui-kit';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Form, Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import ImageViewModal from '../../../../../components/elements/ImageViewModal';
import SearchFilters from '../../../../../components/elements/SearchFilter';
import { deleteAsync, getAsync, postAsync, putAsync } from '../../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import PressReleaseModal from '../PressReleaseModal';
import DatePickerLayout from '../../../../../components/elements/DatePicker';
import { PageHitCountApi } from '../../../../../shared/Helper';
import { useLocation } from 'react-use';
const defaultImgSrc = '/img/defaultImg.jpg';
import { printTable } from '../../../../../utils/tableExportUtils';
export default function ReadPressRelease() {
  const todayDate = new Date();

  const isActive = useSelector((state) => state.toggle.isActive);
  const [values, setValues] = useState({
    title: '',
    publicationDate: '',
    filmingLocation: '',
    keywords: '',
    link: null,
    userID: 0,
    imageSrc: defaultImgSrc,
  });
  const [errors, setErrors] = useState({});
  const [apiData, setApiData] = useState([]);
  const [contentEn, setContentEn] = useState('');
  const [contentAr, setContentAr] = useState('');
  const [title, setTitle] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [newsPlace, setNewsPlace] = useState('');
  const [file, setFile] = useState();
  const [base64URL, setBase64URL] = useState('');
  const [keywords, setKeywords] = useState('');
  const [link, setLink] = useState('');
  const [doc, setDoc] = useState('');
  const [renderLink, setRenderLink] = useState('');
  const [gridModalcreate, setGridModalcreate] = useState(false);
  const [gridModalupdate, setGridModalupdate] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [recordID, setRecordID] = useState(null);
  const [searchTitle, setSearchTitle] = useState('');
  const fileInputRef = useRef(null);

  const toggleShowCreate = (e) => {
    setGridModalcreate(!gridModalcreate);
    setTitleEn('');
    setTitle('');
    setContentAr('');
    setContentEn('');
    setNewsPlace('');
    setKeywords('');
    setBase64URL('');
    setFile('');
    setPublicationDate('');
    fileInputRef.current.value = '';
  };
  const toggleShowUpdate = () => setGridModalupdate(!gridModalupdate);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const { pathname } = useLocation()

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, [])

  const bodyGet = {
    epUserID: epUser,
  };

  const pageOptions = {
    pageNo: 1,
    pageSize: 20,
  };

  const getData = () => {
    setIsLoad(true);
    postAsync('CMSPressRelease/GetPressReleaseFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setNext(pageOptions.pageNo);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    const imgSize = selectedFile.size;
    const extension = selectedFile?.name.split('.')[1];
    if ((extension == 'jpg' || extension == 'png' || extension == 'PNG' || extension == 'jpeg') && imgSize <= 2097152) {
      getBase64(selectedFile)
        .then((result) => {
          selectedFile['base64'] = result;
          setBase64URL(result);
          setDoc(result.split(',')[1]);
          setFile(selectedFile);
          toast.success(t('File uploaded successfully.'));
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        setBase64URL('');
        setFile('');
      }
      toast.error(t('Only PNG, JPG, and JPEG files are allowed. Maximum file size: 2MB.'));
    }
  };

  // const validateCreate = () => {
  //   if (title !== null && title !== "" && titleEn !== null && titleEn !== "" && contentEn !== null && contentEn !== "" && contentAr !== null && contentAr !== ""     )
  // }
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let data = {
        title,
        titleEn,
        contentEn,
        contentAr,
        publicationDate,
        newsPlace :isActive ? newsPlace?.ar_SA : newsPlace?.en_US,
        keywords,
        userID: epUser,
        file,
        base64URL,
      };

      if (
        base64URL == '' ||
        file == '' ||
        // newsPlace == '' ||
        publicationDate == '' ||
        contentAr == '' ||
        contentEn == '' ||
        title == ''
      ) {
        toast.error(t(`please fill all fields`));
      } else {
        await postAsync(
          'CMSPressRelease/CreateCMSPressRelease',
          data,
          {
            headers: {
              Authorization: `Bearer${token}`,
            },
          },
          'multipart/form-data',
        )
          .then((response) => {
            if (response?.statusCode === 200) {
              toast.success(t('Created Successfully'));
              setTitleEn('');
              setTitle('');
              setContentAr('');
              setContentEn('');
              setNewsPlace('');
              setKeywords('');
              setBase64URL('');
              setFile('');
              setDatanotfound(false);
              setPublicationDate('');
               toggleShowCreate(e);
              if (fileInputRef.current) {
                fileInputRef.current.value = '';
              }

              getData();

            }
          })
          .catch((error) => {
            toast.error(t('Something went wrong, Please try again!'));
          });
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const bodyUpdate = {
    title,
    titleEn,
    contentEn,
    contentAr,
    publicationDate,
    newsPlace :isActive ? newsPlace?.ar_SA : newsPlace?.en_US,
    keywords,
    doc,
    file,
    userID: epUser,
  };

  const onUpdate = async (id) => {
     console.log(bodyUpdate,"bodyUpdate")
    // e.preventDefault();
    if (newsPlace == '' || publicationDate == '' || contentAr == '' || contentEn == '' || title == '') {
      toast.error(t(`please fill all fields`));
    } else {
      await putAsync(
        'CMSPressRelease/UpdateCMSPressRelease',
        bodyUpdate,
        {
          id: id,
        },
        'multipart/form-data',
      )
        .then((response) => {
          if (response?.statusCode === 200) {
            toast.success(t('Updated Successfully'));
            navigate('/readpressRelease');
            toggleShowUpdate()
            getData();
          }
        })
        .catch((err) => {
          toast.error(`${t('msg_errorDueTo')}: ${t(err.message)}`);
        });
    }
  };

  // const handleOnSelectCountry = (selectedCountry) => {
  //   const id = selectedCountry.target.value;
  //   setNewsPlace(id);
  // };
   useEffect(() => {
      localStorage.setItem('isHome', false);
      isLogin();
      getData();
    }, []);

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    // getData();
    (async function () {
      try {
        const response = await getAsync('Utilities/GetCountryList');
        const result = response?.data[0];
        // setFilmingLocation(result);
        setNewsPlace(result);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [gridModalcreate, gridModalupdate]);

  const onDelete = async (id) => {
    await deleteAsync('CMSPressRelease/DeleteCMSPressRelease', { id: id })
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(`${t('Deleted Successfully')}`);
          setApiData(response.data);
          getData();
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const showPreview = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setValues({
          ...values,
          imageFile,
          imageSrc: x.target.result,
        });
        const base64 = x.target.result.split(',').splice(1, 1)[0];
        // console.log('image', base64);
        setDoc(base64);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setValues({
        ...values,
        imageFile: null,
        imageSrc: defaultImgSrc,
      });
    }
  };

  const openModal = async (e, pressReleaseID) => {
    e.preventDefault();
    // const selectedLink = apiData?.find((data) => data?.pressReleaseID === pressReleaseID)?.doc;
    try {
      const response = await getAsync('CMSPressRelease/GetByIdCMSPressRelease', {
        id: pressReleaseID,
      });
      setRenderLink(response?.data[0]?.doc);
    } catch (error) {
      console.log(error);
    }

    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };
  const updateRecordById = (e, id) => {
    e.preventDefault();
    toggleShowUpdate();
    getDataByID(id);
    setRecordID(id);
  };

  const handleDownload = async (e, id, fileName) => {
    e.preventDefault();
    try {
      const response = await getAsync('CMSPressRelease/GetByIdCMSPressRelease', { id: id });
      const link = document.createElement('a');
      link.href = `data:image/png;base64,${response?.data[0]?.doc}`; // Update MIME type based on your image format
      link.download = fileName || 'image.png'; // Set the desired file name or fallback to 'image.png'
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(t('Error downloading file Please try Again'));
    }
  };

  const applyErrorClass = (field) => (field in errors && errors[field] === false ? 'invalid-field' : '');

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row className="text-sm" key={index}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{isActive ? data?.title : data?.titleEn}</Table.Cell>
        <Table.Cell>{isActive ? data?.contentAr : data?.contentEn}</Table.Cell>
        <Table.Cell>{data?.publicationDate}</Table.Cell>
        <Table.Cell>{data?.newsPlace ? t(data?.newsPlace) : 'N/A'}</Table.Cell>
        <Table.Cell>{data?.keywords}</Table.Cell>
        <Table.Cell>
          {/* Modal View */}
          <>
            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => openModal(e, data?.pressReleaseID)}
              style={{
                margin: '5px',
              }}
            >
              {' '}
              <VisibilityOutlinedIcon />
            </button>
          </>
          <button
            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
            onClick={(e) => handleDownload(e, data?.pressReleaseID, data?.fileName)}
            style={{ margin: '5px' }}
          >
            <FileDownloadOutlinedIcon />
          </button>
        </Table.Cell>

        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
            type="button"
            onClick={(e) => {
              updateRecordById(e, data?.pressReleaseID);
              setGridModalupdate(true);
            }}
          >
            {t('Update')}
          </button>
          {/* end */}
        </Table.Cell>
        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
            onClick={() => onDelete(data?.pressReleaseID)}
          >
            {t('delete')}
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    //setPageCount(select);
    await postAsync('CMSPressRelease/GetPressReleaseFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getDataByID = async (id) => {
    try {
      const response = await getAsync(`CMSPressRelease/GetByIdCMSPressRelease`, {
        id: id,
      });

      if (response?.data && response?.data.length > 0) {
        const data = response?.data[0];

        setTitle(data?.title);
        setTitleEn(data?.titleEn);
        const date = data?.publicationDate.split('/');
        const formateddate = `${date[2]}-${date[1]}-${date[0]}`;
        setPublicationDate(formateddate);
        setKeywords(data?.keywords);
        setContentEn(data?.contentEn);
        setContentAr(data?.contentAr);
        setLink(data?.link);
        setNewsPlace(data?.newsPlace);
        setDoc(data?.doc);

        toast.info(response?.data?.message);
      } else {
        toast.error(t('Record Not Found.'));
      }
    } catch (err) {
      console.error(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const SearchFilter = {
    // epUserID: epUser,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY') ?? '',
    dateTo: moment(dateTo).format('DD/MM/YYYY') || '',
    cmsTitle: searchTitle,
  };
  const SearchRecord = async () => {
    try {
      setIsLoad(true);
      setDatanotfound(false);
      const response = await postAsync(
        `CMSPressRelease/GetPressReleaseFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Title': isActive ? item.title : item.titleEn,
      'Content': isActive ? item.contentAr : item.contentEn,
      'Publication Date': item.publicationDate,
      'News Place': t(item?.newsPlace),
      'Keywords': item.keywords,
    }));
    downloadCSV(filteredData, 'Read_Press_Release');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Press Release List')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_title`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_content`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_publicationDate`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_newsPlace`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_keywords`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.title : data?.titleEn}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.contentAr : data?.contentEn}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.publicationDate}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.newsPlace ? t(data?.newsPlace) : 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.keywords}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('cms_title'),
      accessor: (row) => isActive ? row?.title : row?.titleEn
    },
     {
      header: t('cms_content'),
      accessor: (row) => isActive ? row?.contentAr : row?.contentEn
    },   {
      header: t('cms_publicationDate'),
      accessor: (row) => isActive ? row?.publicationDate  || 'N/A' : row?.publicationDate  || 'N/A'
    },   {
      header: t('cms_newsPlace'),
      accessor: (row) => isActive ? row?.newsPlace  || 'N/A' : row?.newsPlace || 'N/A'
    },
    {
      header: t('cms_keywords'),
      accessor: (row) => row?.keywords || 'N/A'
    }

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Press Release List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  return (
    <>
      {!isLogin ? (
        <h1>{t('notAuthorized')}</h1>
      ) : (
        <>
          <div className="container-fluid pb-16">
            <div className="row text-center ">
              <div className="col-lg-11 flex justify-end my-4">
                <button
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                  onClick={toggleShowCreate}
                >
                  {t('create')}
                </button>
              </div>
            </div>

            <MDBModal tabIndex="-1" show={gridModalcreate} setShow={setGridModalcreate}>
              <MDBModalDialog className="flex justify-center items-center">
                <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                  <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                    <MDBModalHeader>
                      <MDBModalTitle className="text-customgreen font-semibold">
                        {t('create')} {t('cms_pressRelease')}
                      </MDBModalTitle>
                      {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className="container-fluid bd-example-row">
                        <div className="row" style={{ marginBottom: '5px' }}>
                          <div className="col-md-6 col-example">
                            <Form.Field>
                              <label className="mx-auto text-customgreen">{t('cms_title')} : </label>
                              <input
                                type="text"
                                name="title"
                                value={title}
                                maxLength={1000}
                                className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder={t('Title')}
                              />
                            </Form.Field>
                          </div>
                          <div className="col-md-6 col-example">
                            <Form.Field>
                              <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                              <input
                                type="text"
                                name="title"
                                value={titleEn}
                                maxLength={1000}
                                className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                onChange={(e) => setTitleEn(e.target.value)}
                                placeholder={t('Title')}
                              />
                            </Form.Field>
                          </div>
                          <div className="col-md-6 ms-auto col-example">
                            <Form.Field>
                              <label className="mx-auto text-customgreen">{t('cms_content')} :</label>
                              <textarea
                                type="text"
                                name="content"
                                value={contentAr}
                                className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                onChange={(e) => setContentAr(e.target.value)}
                                placeholder={t('Content')}
                              />
                            </Form.Field>
                          </div>

                          <div className="col-md-6 ms-auto col-example">
                            <Form.Field>
                              <label className="mx-auto text-customgreen">{t('Content En')} :</label>
                              <textarea
                                type="text"
                                name="content"
                                value={contentEn}
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                onChange={(e) => setContentEn(e.target.value)}
                                placeholder={t('Content')}
                              />
                            </Form.Field>
                          </div>

                          <div className="col-md-6 ms-auto col-example">
                            <Form.Field>
                              <label className="mx-auto text-customgreen">{t('News Place')} : </label>
                              <input
                                type="text"
                                disabled
                                name="filmLocation"
                                value={isActive ? newsPlace?.ar_SA : newsPlace?.en_US}
                                className=" border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  cursor-not-allowed"
                                // onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                                placeholder={t('cms_newsPlace')}
                              />

                              {/* { filmingLocation && filmingLocation.length > 0 ? (
                                  filmingLocation?.map((item) => {
                                    return (
                                      <option key={ item.countryID } value={ item?.countryName }>
                                        { isActive ? item?.ar_SA : item?.countryName }
                                      </option>
                                    );
                                  })
                                ) : (
                                  <option>{ t('Select country') }</option>
                                ) }
                              </select> */}
                            </Form.Field>
                          </div>
                          <div className="col-md-6 ms-auto col-example">
                            <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                            <input
                              type="text"
                              name="keywords"
                              value={keywords}
                              onChange={(e) => setKeywords(e.target.value)}
                              className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              placeholder={t('cms_keywords')}
                            />
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: '5px' }}>
                          <div className="col-md-6 form-group flex flex-col ">
                            <DatePickerLayout
                              label={'cms_publicationDate'}
                              selectedDate={publicationDate}
                              keyValue={'to'}
                              dateTo={publicationDate}
                              setDateTo={setPublicationDate}
                              maxDate={todayDate}
                            />
                          </div>
                          <div className="col-md-6 ms-auto col-example">
                            <Form.Field>
                              <label className="mx-auto text-customgreen">{t('cms_image')} :</label>
                              <input
                                ref={fileInputRef}
                                onChange={handleFileInputChange}
                                type="file"
                                className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                placeholder="Upload file"
                                name="Upload file"
                                accept=".png , .jpg , .jpeg"
                              />
                            </Form.Field>
                          </div>

                          <div className="flex justify-center mt-2  ">
                            <img
                              style={{
                                height: '120px',
                                width: '150px',
                              }}
                              src={base64URL ? `${base64URL}` : values.imageSrc}
                              className="card-img-top"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </MDBModalBody>
                    <MDBModalFooter className="flex justify-center">
                      <button
                        className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                        onClick={(e) => {
                          handleSubmit(e);
                        }}
                      >
                        {t('create')}
                      </button>
                      <button
                        className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                        onClick={toggleShowCreate}
                      >
                        {t('close')}
                      </button>
                    </MDBModalFooter>
                  </Form>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

            {/* Image View Modal */}

            <ImageViewModal
              showModal={gridModalOpen}
              setShowModal={setGridModalOpen}
              closeModal={closeModal}
              title={''}
              renderLink={''}
              imgDoc={renderLink}
            />
            {/* Image View Modal End */}

            {/* Modal Update */}

            <PressReleaseModal
              updateRecordById={updateRecordById}
              t={t}
              gridModalupdate={gridModalupdate}
              setGridModalupdate={setGridModalupdate}
              recordID={recordID}
              title={title}
              setTitle={setTitle}
              titleEn={titleEn}
              contentAr={contentAr}
              setContentAr={setContentAr}
              setTitleEn={setTitleEn}
              contentEn={contentEn}
              setContentEn={setContentEn}
              publicationDate={publicationDate}
              setPublicationDate={setPublicationDate}
              newsPlace={newsPlace}
              keywords={keywords}
              setKeywords={setKeywords}
              showPreview={showPreview}
              link={link}
              values={values}
              doc={doc}
              setDoc={setDoc}
              onUpdate={onUpdate}
              onChange={handleFileInputChange}
              fileInputRef={fileInputRef}
            />
            {/* Modal Update End*/}
            <div className="row justify-center flex-row">
              <SearchFilters
                handleSearch={SearchRecord}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'cms_pressRelease'}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={false}
              />
            </div>

            <div className="flex flex-col pt-9">
              <div className="row justify-center">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="col-lg-11 text-center">
                    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                      <Table className="tableData  text-center  rtl:text-right ">
                        <Table.Header className="font-bold text-sm whitespace-nowrap text-center  text-white bg-customgreen uppercase ">
                          <Table.Row className="">
                            <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_title')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_content')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_publicationDate')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_newsPlace')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_keywords')}</Table.HeaderCell>
                            {/* <Table.HeaderCell className="text-white">{ t('View') }</Table.HeaderCell> */}
                            {/* <Table.HeaderCell>{t('cms_userID')}</Table.HeaderCell> */}
                            <Table.HeaderCell>{t('')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                            <Table.HeaderCell>{t('')}</Table.HeaderCell>
                            <Table.HeaderCell>{t('')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body className="text-center">{displayRecords}</Table.Body>
                      </Table>
                    </div>
                    {pageCount > 0 && (
                      <div className="flex flex-row px-12 justify-between">
                        <Menu pagination>
                          <Menu.Item>
                            <ReactPaginate
                              previousLabel={t('Previous')}
                              nextLabel={t('Next')}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={'paginationButtons'}
                              previousLinkClassName={'previousButton'}
                              nextLinkClassName={'nextButton'}
                              disabledClassName={'paginationDisabled'}
                              activeClassName={'paginationActive'}
                            />
                          </Menu.Item>
                        </Menu>
                      </div>
                    )}
                  </div>
                )}
                {datanotfound && <DataNotFound />}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
